import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import { KEYS_CHARCODE } from "./../../editor-common";
import { DropdownModal, ListItemSection, ListItemSelect } from "./../../toolbars-ui";
import { LayoutGridIconNew } from "../assets/icons/LayoutGridIconNew";
import { LayoutListIconNew } from "../assets/icons/LayoutListIconNew";
import {
  LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT,
  LAYOUT_DROPDOWN_OPTION_GRID,
  LAYOUT_DROPDOWN_OPTION_LIST
} from "../data-hooks";
const PollLayoutDropdown = ({
  selectedLayout,
  onLayoutClick,
  onCustomizeButtonClick
}) => {
  const { t, jsdomMode } = useContext(RicosContext) || {};
  const onKeyDown = (e, onClick) => {
    if (e.keyCode === KEYS_CHARCODE.ENTER) {
      onClick();
      e.stopPropagation();
    }
  };
  const CustomizeButton = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ListItemSection, { type: "divider" }), /* @__PURE__ */ React.createElement(
    ListItemSelect,
    {
      title: t("Poll_Mobile_Editor_Toolbar_Customize"),
      onClick: onCustomizeButtonClick,
      dataHook: LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT,
      onKeyDown: (e) => onKeyDown(e, onCustomizeButtonClick)
    }
  ));
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      options: [
        ...Object.entries(dropdownOptions).map(([layout, { dataHook, icon: Icon, text }]) => {
          const onButtonClick = () => onLayoutClick(layout);
          return /* @__PURE__ */ React.createElement(
            ListItemSelect,
            {
              key: layout,
              title: t(text),
              dataHook,
              prefix: /* @__PURE__ */ React.createElement(Icon, null),
              selected: layout === selectedLayout,
              onClick: onButtonClick,
              onKeyDown: (e) => onKeyDown(e, onButtonClick)
            }
          );
        }),
        CustomizeButton
      ],
      jsdomMode
    }
  );
};
const dropdownOptions = {
  GRID: {
    text: "Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid",
    icon: LayoutGridIconNew,
    dataHook: LAYOUT_DROPDOWN_OPTION_GRID
  },
  LIST: {
    text: "Poll_PollSettings_Tab_Layout_Section_Answers_Layout_List",
    icon: LayoutListIconNew,
    dataHook: LAYOUT_DROPDOWN_OPTION_LIST
  }
};
export {
  PollLayoutDropdown,
  dropdownOptions
};
//# sourceMappingURL=poll-layout-dropdown.js.map
